module.exports = __webpack_public_path__ + "assets/07c4806f694b22cc9f0b76a3615f545e.svg";